// SPDX-FileCopyrightText: (C) 2024 Jason Ish <jason@codemonkey.net>
// SPDX-License-Identifier: MIT

export const Colors = [
  "#2962FF",
  "#D50000",
  "#00C853",
  "#FFAB00",
  "#6200EA",
  "#00BFA5",
  "#C51162",
  "#FF6E40",
  "#0091EA",
  "#AA00FF",
  "#FF4081",
  "#00B8D4",
  "#FF5252",
  "#7C4DFF",
  "#FF8A65",
  "#448AFF",
  "#4DB6AC",
  "#81C784",
  "#64DD17",
  "#304FFE",
  "#E57373",
  "#F06292",
  "#BA68C8",
  "#9575CD",
  "#7986CB",
  "#64B5F6",
  "#4FC3F7",
  "#4DD0E1",
  "#AED581",
  "#DCE775",
  "#FFF176",
  "#FFD54F",
  "#FFB74D",
  "#A1887F",
  "#E0E0E0",
  "#90A4AE",
  "#FF8A80",
  "#FF80AB",
  "#EA80FC",
  "#B388FF",
  "#8C9EFF",
  "#82B1FF",
  "#80D8FF",
  "#84FFFF",
  "#A7FFEB",
  "#B9F6CA",
  "#CCFF90",
  "#F4FF81",
  "#FFFF8D",
  "#FFE57F",
  "#FFD180",
  "#FF9E80",
  "#E040FB",
  "#536DFE",
  "#40C4FF",
  "#18FFFF",
  "#64FFDA",
  "#69F0AE",
  "#B2FF59",
  "#EEFF41",
  "#FFFF00",
  "#FFD740",
  "#FFAB40",
  "#AEEA00",
  "#FFD600",
];
